/* eslint-disable import/prefer-default-export */
import { findComponentByFieldName } from '../../Helpers/components';
import trustedFormConfig from '../../Data/Maps/trustedFormConfig';

const findTrustedFormQuestionComponent = (components) => {
  let trustedFormQuestionComponentMap;
  const trustedFormIdentifiers = [
    trustedFormConfig.mappedAdmiralQuestionId,
    trustedFormConfig.questionText,
  ];
  trustedFormIdentifiers.forEach((trustedFormIdentifier) => {
    const componentOrError = findComponentByFieldName(
      trustedFormIdentifier,
      '',
      components
    );
    if (componentOrError && !componentOrError.errorObject) {
      trustedFormQuestionComponentMap = componentOrError;
    }
  });
  if (!trustedFormQuestionComponentMap?.componentId) {
    return undefined;
  }
  return components[`component_${trustedFormQuestionComponentMap.componentId}`];
};

export const isHiddenTrustedFormComponentPresent = (components) => {
  const trustedFormIdentifiers = [
    trustedFormConfig.mappedAdmiralQuestionId,
    trustedFormConfig.questionText,
  ];
  return trustedFormIdentifiers.some((trustedFormIdentifier) => {
    const componentOrError = findComponentByFieldName(
      trustedFormIdentifier,
      '',
      components
    );
    return !!(componentOrError && !componentOrError.errorObject);
  });
};

export const isHiddenTrustedFormQuestionOnFuturePage = (
  currentPage,
  components
) => {
  const trustedFormQuestionComponent =
    findTrustedFormQuestionComponent(components);

  if (!trustedFormQuestionComponent) {
    return false;
  }
  return currentPage < trustedFormQuestionComponent.component.page;
};

export const isTrustedFormCertIdAssignedToHiddenQuestion = (
  trustedFormCertificateId,
  components
) => {
  const trustedFormQuestionComponent =
    findTrustedFormQuestionComponent(components);
  if (!trustedFormQuestionComponent) {
    return false;
  }
  return (
    trustedFormCertificateId ===
    trustedFormQuestionComponent.component.defaultValue
  );
};
